module.exports = __webpack_public_path__ + "img/4x5.b0dad5e6.svg";